import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const portalApi = axios.create({
  baseURL: `${API}/portal`,
  withCredentials: true,
});
